import styled from 'styled-components';
import HourDeskSvg from '../../assets/amenities/24hours-desk.svg';

const HourDeskIcon = styled(HourDeskSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default HourDeskIcon;
